<template>
<section class="content houses_allonewrp export_houses_data_wrp" style="position:relative;">
    <div class="main_select_wrp_relative export_newmodel">
        <div class="filter_wrpp export_houses_wrp">
            <!-- <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogles">
                Export CSV
            </button> -->
        </div>

        <div class="modal fade model_modify_wrp" id="filtertoogles" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog csvExport" role="document" style="width: 50%">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2>Export Houses Data</h2>
                        <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="exportCsvReportClose">
                            Clear All
                        </button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div v-if="csvLoading" class="content content-centered">
                        <pulse-loader></pulse-loader>
                        <p>Please wait, data export is in progress</p>
                    </div>
                    <div v-if="!csvLoading">
                        <div class="modal-body">
                            <div class="main_select_wrp">
                                <div class="flex selectwca_wrp main_select_wrp_houses newexportboxsone">
                                    <div class="multiselected">
                                        <label>Zone</label>
                                        <multiselect track-by="value" v-model="exportsCsv.zones" label="name" placeholder="Select Zone" :options="areas" multiple name="wasteArea" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCsv" @remove="onRemoveCsv"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button class="mr-2 btn gradientbt" type="submit" @click="exportCsvReport">
                                Done
                            </button>
                            <button class="mr-5 btn btn-default" type="button" @click="exportCsvReportClose" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">Cancel</span>
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>

    <div class="main_select_wrp_relative">
        <div class="filter_wrpp filter_houses_wrp">
            <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogles">
                Export CSV
            </button>
            <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                    <g transform="translate(0 -1028.4)">
                        <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                        <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                        <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                        <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                    </g>
                </svg>
                Apply Filter
                    <span :class="{'counter_filter' : count }">{{ count }}</span>
            </button>
        </div>

        <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document" style="width: 50%">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2>Filters</h2>
                        <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter">
                            Clear All
                        </button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="main_select_wrp">
                            <div class="flex selectwca_wrp">
                                <div class="multiselected">
                                    <label>Zone</label>
                                    <multiselect track-by="value" v-model="clearFilters.wasteCollectionArea.value" label="name" placeholder="Select Zone" :options="areas" multiple name="wasteArea" selectLabel="" deselectLabel="" selectedLabel="" @select="onChecked" @remove="onRemove"></multiselect>
                                </div>
                                <div class="multiselected">
                                    <label>CD</label>
                                    <multiselect track-by="value" v-model="clearFilters.collectionDivision.value" label="name" placeholder="Select CD" :options="collectionDivisions" multiple name="divisions" :key="collectionDivisions.length" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCd" @remove="onRemoveCD"></multiselect>
                                </div>
                                <div class="multiselected">
                                    <label>Status</label>
                                    <multiselect track-by="value" v-model="clearFilters.status.value" label="name" placeholder="Select Status" :options="status" multiple name="status" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedStatus" @remove="onRemoveStatus"></multiselect>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="updatehouseDetails" class="houses_details_pop">
        <div class="">
            <div class="">
                <div class=""></div>
                <div id="details house_details_wrp" class="overlay">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <h4 class="editHouse">Edit House Details</h4>
                            <vue-form :state="formstate" class="formadd_scroll formadd_scroll_margin">
                                    <div class="col-sm-12">
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.cityName)">
                                                <label> City Name </label>
                                                <input type="text" name="cityName" class="form-control" required readonly
                                                    v-model="house.cityName" placeholder="City Name" />
                                                <field-messages name="cityName" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">City is a required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.areaName)">
                                                <label> Zone </label>
                                                <input type="text" name="areaName" class="form-control" required readonly
                                                    v-model="house.areaName" placeholder="Zone Name" />
                                                <field-messages name="areaName" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">Zone is a required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.divisionName)">
                                                <label> Division Name </label>
                                                <input type="text" name="divisionName" class="form-control" required
                                                    readonly v-model="house.divisionName" placeholder="Division Name" />
                                                <field-messages name="divisionName" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        Division Name is a required field
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">


                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.areaName)">
                                                <label> Line / Tower Name </label>
                                                <input type="text" name="lineTowerName" class="form-control" required
                                                    readonly v-model="house.lineTowerName" placeholder="Line Name" />
                                                <field-messages name="lineTowerName" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        Line Name is a required field
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.hnNo)">
                                                <label> House Number </label>
                                                <input type="text" name="hnNo" class="form-control" required readonly
                                                    v-model="house.hnNo" placeholder="House Number" />
                                                <field-messages name="hnNo" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        House Number is a required field
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.houseTypeId)">
                                                <label> House Type </label>
                                                <select required v-model="house.houseTypeId" name="houseTypeId"
                                                    class="form-control">
                                                    <option value="" disabled>Select Type</option>

                                                    <option v-for="(type, index) in houseType" :key="index"
                                                        :value="type._id">
                                                        {{ type.name }}
                                                    </option>
                                                </select>
                                                <field-messages name="houseTypeId" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        house Type is a required field
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group"
                                                :class="fieldClassName(formstate.contactPerson)">
                                                <label> Contact Person </label>
                                                <input type="text" name="contactPerson" class="form-control"
                                                    v-model="house.contactPerson" placeholder="Contact Person"
                                                    pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}[^\s]$" />
                                                <!-- <field-messages name="contactPerson" show="$touched || $submitted" class="form-control-feedback validation_msg">
                                                    <div slot="pattern">
                                                        Alphabets/Numbers/Special Characters are allowed.
                                                    </div>
                                                </field-messages> -->
                                            </validate>
                                        </div>
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group">
                                                <!-- <div :class="{
                                  'required-field': house.houseStatus == 'Active',
                                }"> -->
                                                <label> Contact </label>
                                                <!-- </div> -->
                                                <!-- <label>Contact</label> -->
                                                <input type="text" name="contact" class="form-control"
                                                    v-model="house.contact" placeholder="Contact Number"
                                                    pattern="[78965][0-9]{9}" />
                                                <field-messages name="contact" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">Contact is a required field</div>
                                                    <div slot="pattern">Contact Number is Invalid</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group"
                                                :class="fieldClassName(formstate.houseTag)">
                                                <label> Tag </label>
                                                <input maxlength="25" type="text" name="houseTag" class="form-control"
                                                    v-model="house.houseTag" placeholder="Tag"
                                                    pattern="^\S(.*\S)?$" />
                                                <field-messages name="houseTag" show="$touched || $submitted"
                                                    class="form-control-feedback validation_msg">
                                                    <div slot="pattern">
                                                        Alphabets/Numbers/Special Characters are allowed.
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">


                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.memberCount)">
                                                <label> Family Members </label>
                                                <select required v-model="house.memberCount" name="memberCount"
                                                    class="form-control">
                                                    <option v-for="(status, index) in membersArray" :key="index"
                                                        :value="status">
                                                        {{ status }}
                                                    </option>
                                                </select>
                                                <field-messages name="memberCount" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required" show="$touched || $submitted"
                                                        class="form-control-feedback">
                                                        Family members is a required field
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.latitude)">
                                                <label> Latitude </label>
                                                <input type="text" name="latitude" class="form-control" required
                                                    v-model="house.latitude" placeholder="Latitude" />
                                                <field-messages name="latitude" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        Latitude is a required field
                                                    </div>
                                                    <div slot="pattern">
                                                        Latitude must be valid and between -90 to 90
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.longitude)">
                                                <label> Longitude </label>
                                                <input type="text" name="longitude" class="form-control" required
                                                    v-model="house.longitude" placeholder="Longitude" />
                                                <field-messages name="longitude" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">
                                                        Longitude is a required field
                                                    </div>
                                                    <div slot="pattern">
                                                        Longitude must be valid and between -180 to 180
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <div class="col-sm-4">
                                            <validate auto-label class="form-group required-field"
                                                :class="fieldClassName(formstate.status)">
                                                <label> House Status </label>
                                                <select required v-model="house.houseStatus" name="houseStatus"
                                                    class="form-control">
                                                    <option value="" disabled>Select House Status</option>

                                                    <option v-for="(status, index) in houseStatus" :key="index"
                                                        :value="status">
                                                        {{ status }}
                                                    </option>
                                                </select>
                                                <field-messages name="houseStatus" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">Status is a required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                </vue-form>
                            <div class="form-actions">
                                <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                    Cancel
                                </button>
                                <button type="submit" @click="updateHouseInfo" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isSingleMap" class="">
                    <div class="location">
                        <div id="details" class="overlay waste_type_pop">
                            <div class="overlay_inner">
                                <div class="row form-modal">
                                    <div class="d-flex justify-right">
                                        <button @click="onCloseMap" v-bind:class="'mr-5  btn btn-default close-button'">
                                        X
                                    </button>
                                    </div>
                                    <div v-if="houseSingleLocation" class="map-show">
                                        <multiLocation/>
                                    </div>
                                    <div v-if="!houseSingleLocation" class="text-center">
                                        No records Found
                                    </div>
                                    <div class="d-flex justify-right">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

    <v-server-table ref="housesTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
        <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
                <td class="text-center" colspan="6">
                    <pulse-loader></pulse-loader>
                </td>
            </tr>
        </template>

        <template slot="houseStatus" slot-scope="props">
            <div :class= props.row.houseStatus>
                {{ props.row.houseStatus }}
            </div>
        </template>

        <template slot="action" slot-scope="props">
            <div class="d-flex">
                <div class="active_wrp">
                    <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                </div>
                <div class="active_wrp" v-on:click.stop="houseLocationOnMap(props.row)" v-bind:style="{cursor: 'pointer'}">
                                <a class="fa fa-map-marker" v-tooltip.hover title="No Lat Lng Available" role="button" v-bind:style="{
                                    'pointer-events': props.row.geoLoc === '--' ? 'visible' : 'none',
                                }"></a>
                            </div>
                <div class="active_wrp" v-on:click.stop="viewImage(props.row)" v-bind:style="{cursor: 'pointer'}">
                    <a class="fa fa-eye" role="button" v-tooltip.hover title="No Image Available" v-bind:style="{
                        'pointer-events':
                          props.row.houseImage == 'null' ||
                          props.row.houseImage == null ||
                          props.row.houseImage == ''
                            ? 'visible'
                            : 'none',
                      }">
                    </a>

                    <!-- <a
                      role="button"
                      v-b-tooltip.hover
                      title="No Image Available"
                      v-bind:style="
                        props.row.houseImage == 'null' || props.row.houseImage == null
                          ? 'pointer-events: none;'
                          : 'pointer-events: visible;'
                      "
                      v-on:click.stop="viewImage(props.row)"
                      >View</a
                    > -->
                    <!-- <a class="" role="button" v-on:click.stop="viewImage(props.row)">View</a> -->
                </div>
            </div>
        </template>
    </v-server-table>

    <div class="">
        <vue-easy-lightbox escDisabled moveDisabled :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
    </div>
</section>
</template>

    
    
<script>
import VueEasyLightbox from "vue-easy-lightbox";
import store from "../../../store";
import {
    formService,
    housesService,
    eventBus,
    wasteCollectionAreaService,
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";
import multiLocation from "../gmapLocation/multiLocation";

export default {
    name: "houses",
    components: {
        VueEasyLightbox,
        multiLocation
    },
    data() {
        return {
            csvLoading: false,
            isSingleMap: false,
            houseSingleLocation:true,
            data: {},
            exportsCsv: {
                cityIds: {},
                zones: [],
            },
            exportCsvDataCity: {},
            exportCsvDataWard: [],
            type: "house",
            clearFilters: {
                city: "",
                wasteCollectionArea: "",
                collectionDivision: "",
                status: "",
            },
            
            imgs: "",
            visible: false,
            index: 0,
            list: [],
            adminCheck: {},
            updatehouseDetails: false,
            loading: null,
            USER_ROLES: USER_ROLES,
            housesTable: null,
            wcaShow: false,
            cdShow: false,
            house: {
                houseStatus: "",
                memberCount: "",
            },
            membersArray: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
            ],
            formstate: {},
            checkedAreas: [],
            checkedCds: [],
            filters: {},
            checkRole: "",
            areas: [],
            cityList: [],
            parameters: {},
            collectionDivisions: [],
            selectedType: [],
            showImage: false,
            houseImageUrl: "",
            houseData: null,
            statusList: [],
            columns: [
                "areaName",
                "divisionName",
                "lineTowerName",
                "hnNo",
                "houseTag",
                // "geoLoc",
                "contactPerson",
                "contact",
                "memberCount",
                "houseStatus",
                "action",
            ],
            status: [{
                    name: "Active",
                    value: "active"
                },
                {
                    name: "Inactive",
                    value: "inactive"
                },
                {
                    name: "Pending",
                    value: "pending"
                },
            ],
            houseStatus: ["Active", "Inactive"],
            houseType: [],
            count: null,
            count1: 0,
            cityFilterCount: 0,
            zoneFilterCount: 0,
            cdFilterCount: 0,
            statusFilterCount: 0,
            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",
                    areaName: "Zone",
                    divisionName: "Collection Division",
                    lineTowerName: "Line / Tower",
                    hnNo: "HNO",
                    houseTag: "Tag",
                    // geoLoc: "Location",
                    contactPerson: "Contact Person",
                    contact: "Contact",
                    memberCount: "Family",
                    houseStatus: "House Status",
                    action: "Action",
                },
                templates: {},
                perPage: 10,
                sortable: [
                    "cityName",
                    "areaName",
                    "divisionName",
                    "lineTowerName",
                    "hnNo",
                    "geoLoc",
                    "houseTag",
                    "contactPerson",
                    "contact",
                    "memberCount",
                ],
                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    this.parameters.sortBy = "createdAt";
                    this.parameters.sortOrder = "des";
                    this.parameters.searchString = "";

                    if (request.orderBy) {
                        this.parameters.sortBy = request.orderBy;
                        if (request.ascending == 1) {
                            this.parameters.sortOrder = "asc";
                        } else {
                            this.parameters.sortOrder = "des";
                        }
                    }
                    // else {
                    //     this.parameters.sort = "-createdAt";
                    // }

                    if (request.query != "") {
                        this.parameters.searchString = request.query;
                    }
                    if(this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }
                    this.loading = true;
                    return this.$houseDataRepository
                        .getListByPost(this.parameters, this.filters)
                        .catch((error) => {});
                },

                responseAdapter: (response) => {
                    this.loading = false;
                    let houseList = [];
                    let count;
                    response.data.response.forEach((el) => {
                        let data = el;
                        data["contactPerson"] = el.contactPerson ? el.contactPerson : "--";
                        data["contact"] = el.contact ? el.contact : "--";
                        data["houseTag"] = el.houseTag ? el.houseTag : "--";
                        data["geoLoc"] =
                            el.geoLoc != "" || null ? el.geoLoc.reverse().join(", ") : "--";
                        houseList.push(data);
                    });
                    if (houseList.length === 0) {
                        count = 0;
                    }
                    return {
                        data: houseList,
                        count: response.data.total || count,
                    };
                },

                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {
                        //	return row.role[0] == query;
                    },
                }, ],
                uniqueKey: "_id",
            },
        };
    },
    computed: {},
    methods: {
        fieldClassName: formService.fieldClassName,
        exportCsvReportClose() {
            this.exportCsvDataCity.cityId = "";
            this.exportsCsv.cityIds = "";
            this.exportCsvDataWard = [];
            this.exportsCsv.zones = [];
        },
        houseLocationOnMap(data){
            if(data.geoLoc != '--'){
                this.isSingleMap = true;
                let housesInfo = [];
                let geoData = JSON.parse("[" + data.geoLoc + "]");
                if(geoData.length > 0){
                    let house = data;
                    house['lat'] = geoData[0]
                    house['lng'] = geoData[1]
                    housesInfo.push(house)
                }
                if(housesInfo.length > 0){
                    this.houseSingleLocation = true;
                    eventBus.$off("houseZoneEvent");
                    eventBus.$on("houseZoneEvent", ()=> {
                        eventBus.$emit("housesLocation", housesInfo);
                    });
                } else{
                    this.houseSingleLocation = false;
                }   
            }
        },
        onCloseMap(){
            this.isSingleMap = false
        },

        async exportCsvReport() {
            try {
                this.csvLoading = true;
                this.data['type'] = this.type;
                this.data['cityId'] = this.exportCsvDataCity.cityId;
                this.data['wardIds'] = this.exportCsvDataWard;
                const response = await wasteCollectionAreaService.getCSV(this.data);
                this.$snotify.success(`The CSV has been downloaded successfully.`);

                // Assuming that `exportCsvReportClose()` is a function that handles the successful completion of the CSV export.
                this.exportCsvReportClose();
            } catch (error) {
                this.$snotify.error(error.data.message);
                this.exportCsvReportClose();
            } finally {
                this.csvLoading = false;
            }
        },
        onCheckedStatus(option){
            if(this.statusFilterCount === 0){
                this.statusFilterCount = 1;
                this.count += 1;
                this.count1 += 1;
            }
            this.clearFilters.status = option;
            this.statusList.push(option.value);
            if (this.statusList.length > 0) {
                this.filters["houseStatus"] = this.statusList;
            }
            this.$refs.housesTable.refresh();
        },
        onRemoveStatus(option){
            let id = option.value;
            this.statusList = this.statusList.filter((elemant) => elemant != id);
            if (this.statusList.length > 0) {
                this.filters["houseStatus"] = this.statusList;
                this.$refs.housesTable.refresh();
            } else {
                this.statusFilterCount = 0;
                this.count -= 1;
                this.count1 -= 1;
                this.filters.houseStatus = "";
                this.$refs.housesTable.refresh();
            }
        },
        onCheckedCityCsv(option) {            
            this.exportCsvDataWard = [];
            this.exportsCsv.zones = [];
            let cityId = option.value;
            this.exportCsvDataCity.cityId = cityId;
            this.$refs.housesTable.refresh();
            this.getWCAList(cityId);
        },
        onRemoveCityCsv(option) {           
            let cityId = option.value;
            this.exportCsvDataCity.cityId = "";
            this.exportCsvDataWard = [];
            this.exportsCsv.zones = [];
            // this.$refs.housesTable.refresh();

        },
        onCheckedCsv(option) {          
            let id = option.value;
            this.exportCsvDataWard.push(id);

        },
        onRemoveCsv(option) {
            let id = option.value;
            this.exportCsvDataWard = this.exportCsvDataWard.filter((elemant) => elemant != id);

        },

        clearFilter() {
            this.clearFilters = {
           
                wasteCollectionArea: "",
                collectionDivision: "",
                status: "",
            };
  
            this.count = null;
            this.count1 = 0;
            this.zoneFilterCount = 0;
            this.cdFilterCount = 0;
            this.statusFilterCount = 0;
            this.checkedAreas = [];
            this.checkedCds = [];
            
            this.filters = {};
            if(this.$store.state.auth.user.role.key === "superAdmin"){
                this.areas = [];
            }
            // this.areas = [];
            this.towersList = [];
            this.collectionDivisions = [];
            this.$refs.housesTable.refresh();
        },
        onClose() {
            this.updatehouseDetails = false;
        },
        updateHouseInfo() {
            this.house["familyMembers"] = this.house.memberCount.toString();
            if (this.house.houseTag == null || this.house.houseTag == "") {
                delete this.house.houseTag;
            }

            if (this.house.contact == "" || this.house.contact == null) {
                delete this.house.contact;
            }
            if (this.house.contactPerson == "") {
                delete this.house.contactPerson;
            }

            this.house["geoLoc"] = [];
            this.house["geoLoc"][1] = parseFloat(this.house.latitude);
            this.house["geoLoc"][0] = parseFloat(this.house.longitude);
            return housesService
                .updateHouse(this.house)
                .then((response) => {
                    this.updatehouseDetails = false;
                    this.$snotify.success("House Updated Successfully", "Success!");
                    this.$refs.housesTable.refresh();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },
        listRemove(value) {
            if (value.length == 0) {
                this.list = "";
            }
        },
        action(data) {
            this.updatehouseDetails = true;
            return housesService
                .getById(data._id)
                .then((response) => {
                    this.house = response.data.response;
                    if (!response.data.response.houseTypeId) {
                        this.house["houseTypeId"] = this.selectedType[0]._id;
                    } else {
                        this.house["houseTypeId"] = response.data.response.houseTypeId._id;
                    }
                    this.house["houseStatus"] =
                        response.data.response.houseStatus != "Pending" ?
                        response.data.response.houseStatus :
                        "";

                    if (response.data.response.geoLoc.length > 0) {
                        this.house[
                            "latitude"
                        ] = response.data.response.geoLoc[1].toString();
                        this.house[
                            "longitude"
                        ] = response.data.response.geoLoc[0].toString();
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                });
        },
        onLoaded() {
            this.surveysTable = this.$refs.surveysTable;
        },
        showWcaList() {
            this.cdShow = false;
            this.wcaShow = !this.wcaShow;
        },
        showCdList() {
            this.wcaShow = false;
            this.cdShow = !this.cdShow;
        },

        onChecked(option) {
            if(this.zoneFilterCount === 0){
                this.count += 1;
                this.zoneFilterCount = 1;
            }
            this.clearFilters.wasteCollectionArea = option;
            let id = option.value;
            this.checkedAreas.push(id);

            this.wcaSelect(this.checkedAreas);
        },
        onRemove(option) {
            let id = option.value;
            this.checkedAreas = this.checkedAreas.filter((elemant) => elemant != id);
            if(this.zoneFilterCount === 1 && this.cdFilterCount === 1 && this.checkedAreas.length === 0){
                this.count -= 2;
                this.zoneFilterCount = 0;
                this.cdFilterCount = 0;
            }
            if(this.zoneFilterCount === 1 && this.checkedAreas.length === 0 && this.cdFilterCount === 0){
                this.count -= 1;
                this.zoneFilterCount = 0;
            }
            this.wcaSelect(this.checkedAreas);
            this.clearFilters.collectionDivision = "";
        },
        wcaSelect(wcaList) {
            let cdData = [];
            this.filters = {};
            if (wcaList.length > 0) {
                this.filters["areas"] = [...wcaList];
            }
            this.$refs.housesTable.refresh();
            return wasteCollectionAreaService
                .getcollectionDivisionsByAreaId(wcaList)
                .then((response) => {
                    response.data.response.forEach((el) => {
                        let val = {};
                        val["name"] =
                            el.divisionName.length > 20 ?
                            el.divisionName.slice(0, 20) + "..." :
                            el.divisionName;
                        val["value"] = el.divisionId;
                        cdData.push(val);
                    });

                    this.collectionDivisions = cdData.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );

                    const newList = this.collectionDivisions.map((e) => e.value);

                    this.checkedCds = this.checkedCds.filter((e) => newList.includes(e));

                    this.list = this.collectionDivisions.filter((elemant) => {
                        if (this.checkedCds.includes(elemant.value)) return elemant;
                    });

                    this.clearFilters = {
                        ...this.clearFilters, // destructure
                        collectionDivision: {
                            ...this.clearFilters.collectionDivision,
                            value: this.list
                        }
                    }

                });
        },
        onCheckedCd(option) {
            if(this.cdFilterCount === 0){
                this.count += 1;
                this.cdFilterCount = 1;
            }
            this.clearFilters.collectionDivision = option;
            let id = option.value;
            this.checkedCds.push(id);
            this.filters = {
                areas: [...this.checkedAreas],
            };
            if (this.checkedCds.length > 0) {
                this.filters["collectionDivisions"] = this.checkedCds;
            }
            this.$refs.housesTable.refresh();
        },
        onRemoveCD(option) {
            this.filters = {
                areas: [...this.checkedAreas],
            };
            let id = option.value;
            this.checkedCds = this.checkedCds.filter((elemant) => elemant != id);
            if (this.checkedCds.length > 0) {
                this.filters["collectionDivisions"] = this.checkedCds;
            } else {                
                this.count -= 1;
                this.cdFilterCount = 0;
                this.filters.areas = "";
                this.$refs.housesTable.refresh();
            }
            this.$refs.housesTable.refresh();
        },

        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cities.push({
                                name: element.cityName.length > 20 ?
                                    element.cityName.slice(0, 20) + "..." : element.cityName,
                                value: element._id,
                            });
                        }
                    });
                    cities.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.cityList = cities;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },

        onCheckedCity(option) {
            // if(this.cityFilterCount === 1){
            //     this.count = 1;
            //     if(this.count1){
            //         this.count += this.count1;
            //     }
            //     this.zoneFilterCount = 0;
            //     this.cdFilterCount = 0;
            // }
            // if(this.cityFilterCount === 0){
            //     this.cityFilterCount = 1;
            //     this.count += 1;
            // }
            this.checkedAreas = [];
            this.checkedCds = [];
            this.clearFilters.wasteCollectionArea = "";
            this.clearFilters.collectionDivision = "";
            this.clearFilters.status = ""
            this.areas = [];
            this.filters = {};
            this.collectionDivisions = [];
            this.clearFilters.city = option;
            let cityId = option.value;
            // this.getArea(cityId);
            this.parameters.cityId = cityId;
            if(this.$refs.housesTable.refresh){
                this.$refs.housesTable.refresh();
            }
            
            this.getWCAList(cityId);
        },
        onRemoveCity(option) {
            this.count = this.count1;
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.cdFilterCount = 0;
            this.checkedAreas = [];
            this.checkedCds = [];
            this.clearFilters.wasteCollectionArea = "";
            this.clearFilters.collectionDivision = "";
            this.filters = {};
            this.areas = [];
            this.collectionDivisions = [];
            let cityId = option.value;
            this.parameters.cityId = "";
            this.$refs.housesTable.refresh();
            // this.startLocationList = []
            // this.endLocationList = []
        },
        getHouseType() {
            return housesService
                .getHouseType("")
                .then((response) => {
                    response.data.response.forEach((element) => {
                        let val = {};
                        val["name"] = element.name;
                        val["_id"] = element._id;
                        this.houseType.push(val);
                    });
                    this.selectedType = this.houseType.filter(
                        (el) => el.name == "Residential"
                    );
                })
                .catch((error) => {
                    this.$snotify.error("Get House Type list failed", "Error!");
                });
        },

        getWCAList(id) {
            let data = [];
            return housesService
                .getWasteCollectionAreaList(id)
                .then((response) => {
                    response.data.response.forEach((el) => {
                        let val = {};
                        val["name"] =
                            el.areaName.length > 20 ?
                            el.areaName.slice(0, 20) + "..." :
                            el.areaName;
                        val["value"] = el._id;
                        data.push(val);
                    });
                    this.areas = data.sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch((error) => {
                    console.log("error");
                });
        },
        viewImage(house) {
            if (
                !(
                    house.houseImage == "null" ||
                    house.houseImage == null ||
                    house.houseImage == ""
                )
            ) {
                this.imgs = house.houseImage;
                this.houseImageUrl = house.houseImage;
                this.visible = true;
            }
        },

        handleHide() {
            this.visible = false;
        },
    },
    mounted() {
       
        eventBus.$on('cityIdChanged', this.onCheckedCity);
        this.checkRole = this.$store.state.auth.user.role.name;
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
        }
        this.getCityList();
        this.getHouseType();
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onCheckedCity);
    },
    created() {
        if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
            this.parameters.cityId = this.$store.state.auth.cityId.value
            this.getWCAList(this.parameters.cityId);
        }
        this.adminCheck = this.$store.state.auth.user.role.key;
        let cityIdWCAList =
            this.$store.state.auth.user.cityId &&
            this.$store.state.auth.user.cityId._id ?
            this.$store.state.auth.user.cityId._id :
            "";
        if (this.adminCheck !== "superAdmin") {
            this.getWCAList(cityIdWCAList);
        }
    },
};
</script>
    
    
<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #0f6940;
    color: white;
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #0f6940;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #0f6940;
    margin-right: 10px;
}

.tablePopUp {
    border-collapse: collapse;
    border: 1px solid black;
    table-layout: auto;
    width: 440px;
}

.table_scroll {
    height: 200px;
    overflow: auto;
}

/* width */
.table_scroll::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.table_scroll::-webkit-scrollbar-thumb {
    background: #888;
}

.password-popup-width h1 {
    font-size: 22px;
    margin-bottom: 10px;
    font-weight: 600;
}

th,
td {
    border: 1px solid black;
    padding: 5px;
    text-align: left;
}

.password-popup {
    height: 100%;
    width: 100%;
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    text-align: center;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    z-index: 9999;
    background-color: rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tablePopUp {
    border-collapse: collapse;
    border: 1px solid black;
    table-layout: auto;
    width: 440px;
}

.table_scroll {
    height: 200px;
    overflow: auto;
}

.cancelButton {
    background-color: #f44336;
    border-radius: 8px;
    left: 47%;
    position: fixed;
    bottom: 100px;
}

.password-popup-width {
    padding-top: 0px;
    background: #fff;
    width: 500px;
    height: 300px;
    padding: 20px;
    border-radius: 10px;
    position: relative;
}

.password-popup-width .toggle {
    box-shadow: none;
    border: none;
    width: auto;
    position: absolute;
    right: 10px;
    top: 10px;
}

.password-popup-width .toggle svg {
    width: 20px;
    height: 20px;
}

.overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.sidepop {
    position: fixed;
    width: 600px;
    z-index: 9999;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    right: 0;
    top: 0;
    height: 100%;
}

.form-modal {
    background: #fff;
    width: 60%;
    padding: 0;
}

.text-center {
    text-align: center;
}

.overlay_inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.overlay_inner .form-modal h4 {
    background: #f1f1f1;
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #ddd;
    text-align: left;
}

.overlay_inner .form-actions {
    text-align: right;
    padding: 20px 15px;
    border-top: 1px solid #ddd;
    display: inline-block;
    width: 100%;
}

.formadd_scroll {
    /* height: 290px; */
    overflow: auto;
    overflow-x: hidden;
    padding: 15px 0px;
}

.formadd_scroll_margin {
    margin-left: -15px;
    margin-right: -15px;
}

.formadd_scroll::-webkit-scrollbar {
    width: 5px;
}

.formadd_scroll::-webkit-scrollbar-thumb {
    background: #888;
}

.datedrop_boxs_wrapper {
    position: relative;
    z-index: 2;
}

.datedrop_boxs_inner {
    position: absolute;
    right: 185px;
    top: 5px;
}

.datedrop_boxs_inner button {
    background: #0f6940;
    color: #fff;
    border: 0;
    padding: 5px 20px;
    border-radius: 5px;
}

.datedrop_rel_inner .d-flex {
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.editHouse {
    display: flex;
    justify-content: center;
    align-content: center;
}

.multiselected {
    min-width: 145px;
    max-width: 146px;
}

.flex {
    display: flex;
}

@media (max-width: 1199px) {
    .formadd_scroll {
        height: 290px;
    }
}

.filter_houses_wrp {
    position: absolute;
    right: -215px;
    top: -7px;
    z-index: 1;
}

.export_houses_wrp {
    position: absolute;
    right: -75px;
    top: -7px;
    z-index: 1;

}

.main_select_wrp_houses .multiselected {
    min-width: 50.5%;
}

.house-img {
    max-width: 45%;
}

.img-wrapper {
    text-align: center;
    margin: 10px 10px;
}

.main_select_wrp_relative .csvExport {
    width: 57% ;
}

.selectwca_wrp.newexportboxstwo .multiselected {
    min-width: 50.6%;
}

.selectwca_wrp.newexportboxsone .multiselected {
    min-width: 100.6%;
}

.export_newmodel .form-actions {
    text-align: center;
    padding-bottom: 15px;
}
.houses_details_pop .overlay_inner .form-modal h4 {
    justify-content: flex-start;
}

.houses_allonewrp .main_select_wrp_relative {
    position: static;
}
.houses_allonewrp .filter_houses_wrp {
    position: absolute;
    right: 165px;
    display: flex;
    z-index: 1;
    top: 15px;
}
.Active {
    color: #00BD08;
}
.Inactive {
    color: rgb(148, 145, 145);
}
.z_index{
    z-index: 0;
}
.Pending {
    color: #E1BD00;
}


@media(max-width:768px){
.houses_allonewrp .filter_houses_wrp {
    position: static;
    margin-bottom: 10px;
}

}

@media(max-width:767px){
    .main_select_wrp_relative .csvExport {
    width: 95% !important;
}
}
</style>



// WEBPACK FOOTER //
// houses.vue?4e34a43d